/**
 * Catálogo de la landing.
 * Reemplazá `link` por tu URL de afiliado de Mercado Libre.
 * `imagen` es opcional. Si queda vacía, la tarjeta muestra el sello de la categoría.
 */
export const PRODUCTOS = [
  {
    id: 'cargador-bateria-12v',
    nombre: 'Cargador De Bateria De Auto 12v Inteligente 6a Bat Gel',
    categoria: 'Accesorios para Vehículos',
    dato: 'Cargador automático de 12V y 6A con reparación por pulsos, pantalla LCD y corte al terminar. Sirve para baterías AGM, GEL y convencionales de auto, moto o camioneta.',
    link: 'https://meli.la/2Py4wac',
    imagen: 'https://http2.mlstatic.com/D_NQ_NP_2X_912729-MLA112635817168_062026-F.webp',
  },
  {
    id: 'intercomunicador-v6-plus',
    nombre: 'Intercomunicador Moto Casco Auricular Microfono V6 Plus Kit',
    categoria: 'Accesorios para Vehículos',
    dato: 'Kit de dos unidades Bluetooth 5.1 para casco. Hasta 6 personas, alcance de 1,2 km, unas 15 horas de uso y resistencia al agua.',
    link: 'https://meli.la/1PnsW7j',
    imagen: 'https://http2.mlstatic.com/D_NQ_NP_2X_936267-MLA116367617292_092026-F.webp',
  },
  {
    id: 'compresor-arrancador-q8l',
    nombre: '9 En 1 Compresor Arrancador Portátil Powerbank Usb Auto',
    categoria: 'Accesorios para Vehículos',
    dato: 'Arranca el auto (pico de 1500 A) e infla hasta 150 PSI. También carga por USB. Pesa 650 g y entra en el baúl.',
    link: 'https://meli.la/1tYKJRo',
    imagen: 'https://http2.mlstatic.com/D_NQ_NP_2X_620951-MLA116246232186_092026-F.webp',
  },
  {
    id: 'taramps-ts400',
    nombre: 'Amplificador digital Taramps Ts400, módulo Rms de 400 W, 4 canales, 2 ohmios',
    categoria: 'Accesorios para Vehículos',
    dato: 'Módulo Taramps de 400 W RMS, 4 canales y 2 ohmios, para potenciar el audio del vehículo.',
    link: 'https://meli.la/2xLWXfG',
    imagen: 'https://http2.mlstatic.com/D_NQ_NP_2X_992015-MLA110865735646_052026-F.webp',
  },
  {
    id: 'xiaomi-air-compressor-2',
    nombre: 'Compresor De Aire Eléctrico Portátil Xiaomi Air Compressor 2',
    categoria: 'Inflador Vehículo',
    dato: 'Compresor inalámbrico de hasta 150 PSI. Infla un neumático vacío en unos 8 minutos, trae 6 modos y luz para usarlo de noche.',
    link: 'https://meli.la/2u44wVi',
    imagen: 'https://http2.mlstatic.com/D_NQ_NP_2X_665605-MLA100034987181_122025-F.webp',
  },
];
